import { STORAGE_KEYS } from './constants/storage';

export const savePendingLogoutRedirectUrl = (redirectUrl: string | null | undefined) => {
  if (typeof window === 'undefined' || !redirectUrl) {
    return;
  }

  localStorage.setItem(STORAGE_KEYS.LAST_BROWSED_PATH, redirectUrl);
};

export const consumePendingLogoutRedirectUrl = () => {
  if (typeof window === 'undefined') {
    return null;
  }

  const redirectUrl = localStorage.getItem(STORAGE_KEYS.LAST_BROWSED_PATH);

  localStorage.removeItem(STORAGE_KEYS.LAST_BROWSED_PATH);

  return redirectUrl;
};
